module.exports = __webpack_public_path__ + "img/title1.66879f4e.png";